import { CompositeEncoderknecpkexzn3v as CompositeEncoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { StringDeferringEncoder2g68f2tkdfmtv as StringDeferringEncoder } from './StringDeferringEncoder.mjs';
import { Error3ofk6owajcepa as Error_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { LIST_getInstance2vniy0f7mmb29 as LIST_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import {
  Companion_getInstance1iw2ra7dwm7v5 as Companion_getInstance,
  appendCsvr9yu6rqb1co7 as appendCsv,
} from './CsvConfig.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { sequenceOf1mtha40gp6gat as sequenceOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class;
function CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1() {
  if (CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class === VOID) {
    class $ {
      constructor($og, this$0) {
        this.$og_1 = $og;
        this.this$0__1 = this$0;
        this.$$delegate_0__1 = $og;
      }
      endStructure_1xqz0n_k$(descriptor) {
        this.this$0__1.onComplete_1(this.$og_1.map_1);
      }
      shouldEncodeElementDefault_x8eyid_k$(descriptor, index) {
        return this.$$delegate_0__1.shouldEncodeElementDefault_x8eyid_k$(descriptor, index);
      }
      encodeBooleanElement_ydht7q_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeBooleanElement_ydht7q_k$(descriptor, index, value);
      }
      encodeByteElement_kft2ib_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeByteElement_kft2ib_k$(descriptor, index, value);
      }
      encodeShortElement_4bcdph_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeShortElement_4bcdph_k$(descriptor, index, value);
      }
      encodeCharElement_5nnekk_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeCharElement_5nnekk_k$(descriptor, index, value);
      }
      encodeIntElement_krhhce_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeIntElement_krhhce_k$(descriptor, index, value);
      }
      encodeLongElement_ovnxxh_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeLongElement_ovnxxh_k$(descriptor, index, value);
      }
      encodeFloatElement_oe8hn_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeFloatElement_oe8hn_k$(descriptor, index, value);
      }
      encodeDoubleElement_a6rqhe_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeDoubleElement_a6rqhe_k$(descriptor, index, value);
      }
      encodeStringElement_1n5wu2_k$(descriptor, index, value) {
        this.$$delegate_0__1.encodeStringElement_1n5wu2_k$(descriptor, index, value);
      }
      encodeInlineElement_69jjkk_k$(descriptor, index) {
        return this.$$delegate_0__1.encodeInlineElement_69jjkk_k$(descriptor, index);
      }
      encodeSerializableElement_isqxcl_k$(descriptor, index, serializer, value) {
        this.$$delegate_0__1.encodeSerializableElement_isqxcl_k$(descriptor, index, serializer, value);
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        this.$$delegate_0__1.encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [CompositeEncoder()]);
    CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class = $;
  }
  return CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class;
}
var CsvFormat$TopListEncoder$beginStructure$1Class;
function CsvFormat$TopListEncoder$beginStructure$1() {
  if (CsvFormat$TopListEncoder$beginStructure$1Class === VOID) {
    class $ extends AbstractEncoder() {
      constructor(this$0, this$1) {
        return new.target.new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder__no_name_provided__vvdie_k$(this$0, this$1);
      }
      static new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder__no_name_provided__vvdie_k$(this$0, this$1, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        $box.this$1__1 = this$1;
        return this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
      }
      get_serializersModule_piitvg_k$() {
        return this.this$0__1.stringDeferringConfig_1.serializersModule_1;
      }
      beginStructure_yljocp_k$(descriptor) {
        var og = new (StringDeferringEncoder())(this.this$0__1.stringDeferringConfig_1, false);
        return new (CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1())(og, this.this$1__1);
      }
      encodeValue_g68i1f_k$(value) {
        (new (StringDeferringEncoder())(this.this$0__1.stringDeferringConfig_1, false)).encodeTaggedValue_sfcjfh_k$('', value);
      }
    }
    initMetadataForClass($);
    CsvFormat$TopListEncoder$beginStructure$1Class = $;
  }
  return CsvFormat$TopListEncoder$beginStructure$1Class;
}
var TopListEncoderClass;
function TopListEncoder() {
  if (TopListEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, onComplete) {
        return new.target.new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder_9dukzg_k$($outer, onComplete);
      }
      static new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder_9dukzg_k$($outer, onComplete, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.onComplete_1 = onComplete;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.$this_1.stringDeferringConfig_1.serializersModule_1;
      }
      beginStructure_yljocp_k$(descriptor) {
        if (!equals(descriptor.get_kind_wop7ml_k$(), LIST_getInstance()))
          throw Error_0().new_kotlin_Error_8ce653_k$();
        return CsvFormat$TopListEncoder$beginStructure$1().new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder__no_name_provided__vvdie_k$(this.$this_1, this);
      }
      encodeValue_h3w5i5_k$(value) {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
      encodeValue_g68i1f_k$(value) {
        return this.encodeValue_h3w5i5_k$(value);
      }
    }
    initMetadataForClass($, 'TopListEncoder');
    TopListEncoderClass = $;
  }
  return TopListEncoderClass;
}
var CsvFormatClass;
function CsvFormat() {
  if (CsvFormatClass === VOID) {
    class $ {
      constructor(stringDeferringConfig, csvConfig) {
        csvConfig = csvConfig === VOID ? Companion_getInstance().default_1 : csvConfig;
        this.stringDeferringConfig_1 = stringDeferringConfig;
        this.csvConfig_1 = csvConfig;
      }
      encodeToString_k0apqx_k$(serializer, value) {
        var tmp0_subject = serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
        var tmp;
        if (equals(tmp0_subject, LIST_getInstance())) {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
          var maps = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          serializer.serialize_5ase3y_k$(TopListEncoder().new_com_lightningkite_kotlinx_serialization_csv_CsvFormat_TopListEncoder_9dukzg_k$(this, (it) => {
            // Inline function 'kotlin.collections.plusAssign' call
            maps.add_utx5q5_k$(it);
            return Unit_instance;
          }), value);
          appendCsv(this_0, asSequence(maps), this.csvConfig_1);
          tmp = this_0.toString();
        } else {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_1 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
          // Inline function 'kotlin.apply' call
          var this_2 = new (StringDeferringEncoder())(this.stringDeferringConfig_1, false);
          this_2.encodeSerializableValue_3uuzip_k$(serializer, value);
          // Inline function 'kotlin.let' call
          var it = this_2.map_1;
          var tmp$ret$9 = sequenceOf([it]);
          appendCsv(this_1, tmp$ret$9);
          tmp = this_1.toString();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'CsvFormat');
    CsvFormatClass = $;
  }
  return CsvFormatClass;
}
//region block: exports
export {
  CsvFormat as CsvFormat2d7d3ollhiney,
};
//endregion

//# sourceMappingURL=CsvFormat.mjs.map
